"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Viewers(_a) {
    var _b = _a.viewers, viewers = _b === void 0 ? 0 : _b, _c = _a.enabled, enabled = _c === void 0 ? true : _c;
    return react_1.default.createElement("div", { className: 'storybook-livestreams-viewers' },
        react_1.default.createElement("span", null, "Live"),
        (enabled && viewers > 0) && react_1.default.createElement("div", { className: 'storybook-livestreams-viewers-count' },
            react_1.default.createElement(storybook_1.Icons.Icon, { className: 'w-4', name: 'eye' }),
            viewers));
}
exports.default = Viewers;
